import React, { useRef } from "react";
import Search from "canvas-core-react/lib/Search";
import { useTranslation } from "react-i18next";
import Client from "../../../../static/images/find-institution.svg";

const SearchUser = ({ onSearch, name, placeholder }) => {
  const ref = useRef();
  const { t } = useTranslation();
  return (
    <div className="main-backoffice userbac search-cod-fix">
      <img src={Client} className="clientImage" />
      <p className="welcome">{t("registerProvider.forms.user.search.title")}</p>
      <p className="client">{t("registerProvider.forms.user.search.action")}:</p>
      <div className="line red" />
      <Search
        id={name}
        placeholder={placeholder}
        name={name}
        className="search-box"
        onSearchClick={() => onSearch(ref.current.value)}
        clearButtonLabel="borrar"
        inputRef={ref}
        searchButtonLabel="search"
        label=""
        value=""
      />
    </div>
  );
};

export default SearchUser;
